var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.config.title,
        visible: _vm.dialogVisible,
        width: _vm.config.width,
        "before-close": _vm.handleClose,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "current" },
        [
          _c("el-scrollbar", { staticStyle: { height: "100%" } }, [
            _vm.tableData.length > 0
              ? _c(
                  "div",
                  { staticClass: "current-list" },
                  [
                    _c(
                      "div",
                      { staticClass: "total-score" },
                      [
                        _c("p", [
                          _c("span", { staticClass: "total-score-name" }, [
                            _vm._v(_vm._s(_vm.$t("access.totalscore")) + ":"),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "number" }, [
                            _vm._v(_vm._s(_vm.assessInfo.max)),
                          ]),
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.tableData, function (item, index) {
                          return _c("p", { key: index }, [
                            _c("span", { staticClass: "total-score-name" }, [
                              _vm._v(_vm._s(item.name) + ":"),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "number" }, [
                              _vm._v(_vm._s(_vm.sum(index))),
                            ]),
                          ])
                        }),
                        _vm._v(" "),
                        _c("p", [
                          _c("span", { staticClass: "total-score-name" }, [
                            _vm._v(_vm._s(_vm.$t("access.totalscore1")) + ":"),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "number" }, [
                            _vm._v(_vm._s(_vm.totalSum())),
                          ]),
                        ]),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.tableData, function (item, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "current-table" },
                        [
                          _c("div", { staticClass: "current-table-title" }, [
                            !_vm.testAccess
                              ? _c("div", [
                                  _c("span", [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: item.name,
                                          expression: "item.name",
                                        },
                                      ],
                                      staticClass: "current-title-input",
                                      style: { width: _vm.text(item.name) },
                                      attrs: { autofocus: true, type: "text" },
                                      domProps: { value: item.name },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            item,
                                            "name",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("access.dimensionweight"))
                                      ),
                                      _c("el-input-number", {
                                        attrs: {
                                          controls: false,
                                          min: 0,
                                          max: item.weight,
                                        },
                                        model: {
                                          value: item.ratio,
                                          callback: function ($$v) {
                                            _vm.$set(item, "ratio", $$v)
                                          },
                                          expression: "item.ratio",
                                        },
                                      }),
                                      _vm._v("%"),
                                    ],
                                    1
                                  ),
                                ])
                              : _c("div", [
                                  _c("span", [_vm._v(_vm._s(item.name))]),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.assessInfo.types == 0
                                            ? _vm.$t("access.dimensionweight")
                                            : _vm.$t("access.dimensionscore")
                                        ) +
                                        "\n                " +
                                        _vm._s(item.ratio) +
                                        "\n                " +
                                        _vm._s(
                                          _vm.assessInfo.types == 0 ? "%" : ""
                                        ) +
                                        "\n              "
                                    ),
                                  ]),
                                ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-table",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                data: item.target,
                                "row-key": "id",
                                "default-expand-all": "",
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  prop: "name",
                                  label: _vm.$t("access.targetname"),
                                  "min-width": "100",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          !_vm.testAccess
                                            ? _c("el-input", {
                                                attrs: { type: "text" },
                                                model: {
                                                  value: scope.row.name,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      "name",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "scope.row.name",
                                                },
                                              })
                                            : _c("span", [
                                                _vm._v(_vm._s(scope.row.name)),
                                              ]),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "content",
                                  label: _vm.$t("access.targetexplain"),
                                  "min-width": "200",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          !_vm.testAccess
                                            ? _c("el-input", {
                                                attrs: { type: "text" },
                                                model: {
                                                  value: scope.row.content,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      "content",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "scope.row.content",
                                                },
                                              })
                                            : _c("span", [
                                                _vm._v(
                                                  _vm._s(scope.row.content)
                                                ),
                                              ]),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "finish_info",
                                  label: _vm.$t("access.completion"),
                                  "min-width": "180",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _vm.testAccess
                                            ? _c("el-input", {
                                                attrs: { type: "text" },
                                                model: {
                                                  value: scope.row.finish_info,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      "finish_info",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "scope.row.finish_info",
                                                },
                                              })
                                            : _c("span", [
                                                _vm._v(
                                                  _vm._s(scope.row.finish_info)
                                                ),
                                              ]),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "check_info",
                                  label: _vm.$t("access.higherevaluation"),
                                  "min-width": "180",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          !_vm.testAccess
                                            ? _c("el-input", {
                                                attrs: {
                                                  type: "text",
                                                  placeholder: "上级评价",
                                                },
                                                model: {
                                                  value: scope.row.check_info,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      "check_info",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "scope.row.check_info",
                                                },
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.testAccess
                                            ? _c("span", [
                                                _vm._v(
                                                  _vm._s(scope.row.check_info)
                                                ),
                                              ])
                                            : _vm._e(),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "ratio",
                                  label:
                                    _vm.assessInfo.types == 0
                                      ? _vm.$t("access.weight")
                                      : _vm.$t("access.score"),
                                  "min-width": "100",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "div",
                                            { staticClass: "current-task" },
                                            [
                                              !_vm.testAccess
                                                ? _c("el-input", {
                                                    attrs: { type: "text" },
                                                    model: {
                                                      value: scope.row.ratio,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "ratio",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.ratio",
                                                    },
                                                  })
                                                : _c("span", [
                                                    _vm._v(
                                                      _vm._s(scope.row.ratio)
                                                    ),
                                                  ]),
                                              _vm._v(" "),
                                              _vm.assessInfo.types == 0
                                                ? _c("span", [_vm._v("%")])
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                              _vm._v(" "),
                              _vm.assessInfo.types == 0
                                ? _c("el-table-column", {
                                    attrs: {
                                      prop: "task",
                                      label: _vm.$t("access.degree"),
                                      "min-width": "100",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "div",
                                                { staticClass: "current-task" },
                                                [
                                                  _c("el-progress", {
                                                    attrs: {
                                                      type: "circle",
                                                      "show-text": false,
                                                      "stroke-width": 3,
                                                      width: 18,
                                                      percentage: Number(
                                                        scope.row.finish_ratio
                                                      ),
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  !_vm.testAccess
                                                    ? _c("el-input", {
                                                        attrs: { type: "text" },
                                                        model: {
                                                          value:
                                                            scope.row
                                                              .finish_ratio,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              scope.row,
                                                              "finish_ratio",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "scope.row.finish_ratio",
                                                        },
                                                      })
                                                    : _c(
                                                        "span",
                                                        {
                                                          staticStyle: {
                                                            "padding-left":
                                                              "6px",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              scope.row
                                                                .finish_ratio
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                  _vm._v(
                                                    " %\n                "
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  })
                                : _c("el-table-column", {
                                    attrs: {
                                      prop: "task",
                                      label: _vm.$t("access.completion1"),
                                      "min-width": "100",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "div",
                                                { staticClass: "current-task" },
                                                [
                                                  _vm.testAccess
                                                    ? _c("el-input", {
                                                        attrs: { type: "text" },
                                                        model: {
                                                          value:
                                                            scope.row
                                                              .finish_ratio,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              scope.row,
                                                              "finish_ratio",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "scope.row.finish_ratio",
                                                        },
                                                      })
                                                    : _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            scope.row
                                                              .finish_ratio
                                                          )
                                                        ),
                                                      ]),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "score",
                                  label: _vm.$t("access.superiorgrade"),
                                  "min-width": "60",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "div",
                                            { staticClass: "current-task" },
                                            [
                                              !_vm.testAccess
                                                ? _c("el-input-number", {
                                                    attrs: {
                                                      placeholder:
                                                        _vm.$t("access.score"),
                                                      controls: false,
                                                      min: 0,
                                                      max: 100,
                                                    },
                                                    model: {
                                                      value: scope.row.score,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "score",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.score",
                                                    },
                                                  })
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.testAccess
                                                ? _c("span", [
                                                    _vm._v(
                                                      _vm._s(scope.row.score)
                                                    ),
                                                  ])
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    }),
                  ],
                  2
                )
              : _vm._e(),
          ]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }